import {BaseApi} from "@/core/api/base.api";
import {Room} from "@/core/api/room.api";
import {RoomCall} from "@/core/api/room.call.api";
import {GrmWebRTC} from "@/lib/gooroomee/webrtc/GrmWebRTC";

import _ from "lodash";
import {Device} from "@/utils";
import GrmMediaStreamTrack from '@/lib/gooroomee/track-generator/GrmMediaStreamTrack'
import "@/lib/gooroomee/webrtc/GrmWebRTC.adapter";

class RoomCallStreamApi extends BaseApi {
    #deviceCap = {};
    #createLocalStreamJobData = {
        jobs: []
    };
    #streamObj = {
        previewStream: new MediaStream(),
        localStream: new MediaStream(),
        processedStream: new MediaStream(),
        oriScreenStream: null,
        screenStream: null,
    };

    #streamMerger = null;
    #streamMergerPipMatrix

    constructor() {
        super();
        RoomCall.Stream = this;

        navigator.mediaDevices?.addEventListener('devicechange', async e => {
            let devices = await this.getUserDevices();
            Room.emit('devicechange', {devices});
        });
    }

    destroy () {
        for(let key in this.#streamObj){
            let stream = this.#streamObj[key];
            if(!stream) continue;
            GrmWebRTC.stopMediaStream(stream)
                .catch(console.error);
        }
    }

    async getUserDevices() {
        let devices = await GrmWebRTC.getUserDevice()
        return devices;
    }

    getVideoMirror() {
        const info = this.getLocalDeviceSetting()
        return !!info?.video?.usePreviewMirror
    }
    getLocalDeviceSetting() {
        let setting = (() => {
            let str = localStorage.getItem('grm.room.device.setting');
            if(str){
                return JSON.parse(str);
            }
            return {video: { deviceId: null, virtualBackgroundType: 'none', usePreviewMirror: true }, audio: { deviceId: null, useNoiseCancel: true }};
        })();
        return setting;
    }
    setLocalDeviceSetting(settings) {
        let current = this.getLocalDeviceSetting();
        _.merge(current, settings);
        localStorage.setItem('grm.room.device.setting', JSON.stringify(current));
    }

    async setCurrentScreenStream({stream, options}) {
    }
    getCurrentScreenStream() {
    }
    getCurrentOriScreenStream() {
    }

    async removeCurrentLocalStream () {
        await GrmWebRTC.stopMediaStream([
            this.#streamObj.localStream,
        ]);
    }

    async createLocalStream(options) {
        const { localStream } = this.#streamObj;
        let currVideoTrack = localStream.getVideoTracks()[0];
        let grmTrackGen = currVideoTrack?.GrmTrack.getTrackGenerator();
        // let currAudioTrack = this.#streamObj.localStream.getAudioTracks()[0];

        if(options.video){
            if(currVideoTrack){
                currVideoTrack = currVideoTrack.GrmTrackUtils().getOriTrack() || currVideoTrack;

                let {deviceId} = options.video;
                if(deviceId && (typeof deviceId === 'object' && deviceId.exact)){
                    deviceId = deviceId.exact;
                }
                const settings = currVideoTrack.getSettings();
                if(settings.deviceId === deviceId){
                    let cons = currVideoTrack.getConstraints();
                    let mod = Object.assign({}, options.video);
                    delete mod.deviceId;
                    Object.assign(cons, mod);
                    await currVideoTrack.applyConstraints(cons);
                }else{
                    currVideoTrack.stop();
                    // localStream.removeTrack(localStream.getVideoTracks()[0]);
                    currVideoTrack = null;
                }
            }
            if(!currVideoTrack){
                if(options.video.deviceId){
                    let deviceId = options.video.deviceId;
                    if(typeof deviceId === 'object'){
                        deviceId = deviceId.exact;
                    }
                    if(deviceId){
                        const devices = (await navigator.mediaDevices.enumerateDevices()).filter(d => d.kind==='videoinput');
                        const device = devices.find(device => device.deviceId === deviceId);
                        if(!device){
                            deviceId = null;
                        }
                    }
                    if(deviceId){
                        options.video.deviceId = {exact: deviceId};
                    }else{
                        delete options.video.deviceId;
                    }
                }

                const constraints = {video: options.video}
                const vStream = await GrmWebRTC.getUserMedia(constraints);
                // const track = vStream.getVideoTracks()[0];

                if(grmTrackGen){
                    grmTrackGen.replaceVideoMediaStreamTrack(vStream.getVideoTracks()[0]);
                }else{
                    let newTrack = await vStream.getVideoTracks()[0].convertToGrmTrack({
                        stream: vStream
                    }, {
                        // type: 'canvas'
                        // type: 'canvasWorker'
                        type: 'trackGeneratorWorker'
                    })
                    grmTrackGen = newTrack.GrmTrackUtils().getTrackGenerator();
                    await grmTrackGen.pipeThrough('BlurFilter', {direction: 'top-down'})
                }

                const tTrack = grmTrackGen.getVideoMediaStreamTrack();
                // worker 의 경우 첫 frame write 에 시간이 걸릴 수 있음.
                await new Promise((resolve, reject) => {
                    setTimeout(() => {
                        resolve();
                    }, 5);
                });

                localStream.addTrack(tTrack);
            }
        }

        return localStream;
    }

    ////@@@@@@@@@@@@@@@@@/////////////////////////////////////////////////

    getCurrentProcessedStream() {
        return this.#streamObj.processedStream;
    }
    async getCurrentLocalStream(immediate) {
        if(immediate !== true && this.#createLocalStreamJobData.jobs.length > 0){
            window.sss = this.#createLocalStreamJobData.jobs[0];
            await this.#createLocalStreamJobData.jobs[0];
        }

        // if(this.useVirtualBackground()){
        //     return this.#streamObj.processedStream;
        // }else{
        // }
        return this.#streamObj.localStream;
    }
    getCurrentPreviewStream() {
        // if(this.useVirtualBackground())
        //     return this.#streamObj.processedStream;
        return this.#streamObj.localStream;
        // return this.#streamObj.previewStream || this.#streamObj.localStream;
        // let stream = this.#streamObj.previewStream;
        // if(!stream){
        //     stream = this.#streamObj.previewStream = new MediaStream();
        //     if(this.#streamObj.localStream && this.#streamObj.localStream.getVideoTracks().length > 0){
        //         stream.addTrack(
        //             this.#streamObj.localStream.getVideoTracks()[0]
        //         );
        //     }
        // }
        // return stream;
    }
    async getSendLocalStreamVideoTrack () {
        const stream = await this.getCurrentLocalStream(true);
        if(!stream) return null;
        let track = stream.getVideoTracks()[0];
        return track;
    }

    async removeCurrentPreviewStream () {
        await GrmWebRTC.stopMediaStream([
            this.#streamObj.previewStream,
        ]);
    }

    getStreamMerger(options) {
        if(!this.#streamMerger){
            this.#streamMerger = new VideoStreamMerger(options);
        }
        return this.#streamMerger;
    }
    
    setStreamMergerOutputSize({width, height}){
        this.#streamMerger.setOutputSize(width, height);
    }
    
    resizeMergedStream({x, y, width, height}){
        // this.streamMergerDebounce = this.streamMergerDebounce || _.debounce(({x, y, width, height}) => {
        Object.assign(this.#streamMergerPipMatrix, {
            x, y,
            width ,height,
        })        
        // }, 100);
        //
        // this.streamMergerDebounce(options);
    }
    
    resizeMergedStreamRelatively({ratioX, ratioY, ratioWidth, ratioHeight}){
        const streamMerger = this.getStreamMerger();
        if(!streamMerger) return;

        const {width, height} = streamMerger;
        const newWidth = ratioWidth * width;
        const newHeight = ratioHeight ?
            ratioHeight * height
            : newWidth * this.#streamMergerPipMatrix.height / this.#streamMergerPipMatrix.width;
            
        this.resizeMergedStream({
            x: ratioX * width,
            y: ratioY * height,
            width: newWidth,
            height: newHeight,
        })
    }

    moveMergedStream({x, y}){
        Object.assign(this.#streamMergerPipMatrix, {
            x, y,
        })
    }

    moveMergedStreamRelatively({ratioX, ratioY}){
        const streamMerger = this.getStreamMerger();
        if(!streamMerger) return;
        
        const {width, height} = streamMerger;
        this.moveMergedStream({
            x: ratioX * width,
            y: ratioY * height,
        })
    }
    
    updateMergedScreenStream(){
        const streamMerger = this.getStreamMerger();
        const canvasCtx = streamMerger._ctx;
        if(canvasCtx){
            const canvas = canvasCtx.canvas;
            let {width, height} = this.#streamObj.oriScreenStream.getVideoTracks()[0].getSettings();
            if(width < 200) width = 200;
            if(height < 200) height = 200;

            if(canvas.width != width){
                if(width < this.#streamMergerPipMatrix.width){
                    this.#streamMergerPipMatrix.x = 0
                    this._resizeMergedPipStream({ratio: width / this.#streamMergerPipMatrix.width})
                }
                if(width < this.#streamMergerPipMatrix.width + this.#streamMergerPipMatrix.x){
                    const ratio = width / canvas.width;
                    this._resizeMergedPipStream({ratio})
                }
                streamMerger.width = canvas.width = width;
            }
            if(canvas.height != height){
                if(height < this.#streamMergerPipMatrix.height){
                    this.#streamMergerPipMatrix.y = 0
                    this._resizeMergedPipStream({ratio: height / this.#streamMergerPipMatrix.height})
                }
                if(height < this.#streamMergerPipMatrix.height + this.#streamMergerPipMatrix.x){
                    const ratio = height / canvas.height;
                    this._resizeMergedPipStream({ratio})
                }
                streamMerger.height = canvas.height = height;
            }
        }
    }
    
    _resizeMergedPipStream({ratio}){
        this.#streamMergerPipMatrix.width   *= ratio
        this.#streamMergerPipMatrix.height  *= ratio
        this.#streamMergerPipMatrix.x       *= ratio
        this.#streamMergerPipMatrix.y       *= ratio
    }
    
    getStreamMergerMatrix(){
        const streamMerger = this.getStreamMerger();
        if(!streamMerger) return {};
        
        const {x, y, width, height} = this.#streamMergerPipMatrix;
        return {
            canvasRatioX: x / streamMerger.width,
            canvasRatioY: y / streamMerger.height,
            canvasRatioWidth: width / streamMerger.width,
            canvasRatioHeight: height / streamMerger.height,
        };
    }

    getStreamMergerPipMatrix(){
      return this.#streamMergerPipMatrix;
    }
    
    async mergeScreenStreamAndLocalStream(options={}){
        const localStream = await this.getCurrentLocalStream();
        const oriScreenStream = this.#streamObj.oriScreenStream;
        const oriScreenTrack = oriScreenStream.getVideoTracks()[0];
        const oriScreenSettings = oriScreenTrack.getSettings();
        
        const {width, height} = localStream.getVideoTracks()[0].getSettings();
        const pipRatio = Math.min(oriScreenSettings.width/width, oriScreenSettings.height/height);
        
        if(typeof pipRatio !== 'number') {
            console.error('trackWidth or trackHeight is not a number')
            return this.#streamObj.screenStream = this.#streamObj.oriScreenStream
        }
        
        const streamMerger = this.getStreamMerger({
            width: oriScreenSettings.width,
            height: oriScreenSettings.height,
            fps: oriScreenSettings.frameRate,
        });
        streamMerger.addStream(oriScreenStream, {
            index: 0,
            mute: false,
            draw: (ctx, frame, done) => {
                ctx.drawImage(frame, 0, 0, streamMerger.width, streamMerger.height)
                done()
            }
        })
        
        const pipMargin = 0.1;
        const pipRatioWidth     = pipRatio * width / 2;
        const pipRatioHeight    = pipRatio * height / 2;
        const pipX = oriScreenSettings.width - pipRatioWidth;
        const pipY = oriScreenSettings.height - pipRatioHeight;
        options = this.#streamMergerPipMatrix = Object.assign( {}, {
            x: pipX,
            y: pipY,
            width: pipRatioWidth * (1 - pipMargin),
            height: pipRatioHeight * (1 - pipMargin),
            index: 1,
            mute: true
        }, options)
        streamMerger.addStream(localStream, {
            ...options,
            draw: (ctx, frame, done) => {
                ctx.drawImage(frame, options.x, options.y, options.width, options.height)
                done()
            }
        })

        this.setStreamMergerOutputSize(oriScreenSettings);
        streamMerger.start()
        this.#streamObj.screenStream = streamMerger.result
    }

    removeScreenStream() {
        GrmWebRTC.stopMediaStream(this.#streamObj.oriScreenStream);
        GrmWebRTC.stopMediaStream(this.#streamObj.screenStream)
        this.#streamObj.oriScreenStream = null;
        this.#streamObj.screenStream = null;
        this.#streamMerger?.destroy();
    }
    async getCurrentStreamIdsData(options={}) {
        let map = {};

        if(options.conn?.isUnifiedPlan()){
            const conn = options.conn;
            const transceivers = conn.getPeerConnection().getTransceivers();
            const data = map;
            data.streamParams = data.streamParams || {};

            const localStream = await this.getCurrentLocalStream();
            const screenStream = this.getCurrentScreenStream();
            if(localStream){
                localStream.getTracks().forEach(t => {
                    let trans = transceivers.find(trans => {
                        return trans.sender
                            && trans.sender.track === t;
                    });
                    if(!trans) return;
                    data.streamParams[t.kind+'TrackMid'] = trans.mid;
                });
            }
            if(screenStream){
                screenStream.getTracks().forEach(t => {
                    let trans = transceivers.find(trans => {
                        return trans.sender
                            && trans.sender.track === t;
                    });
                    if(!trans) return;
                    let name = 'screen' + t.kind.substring(0,1).toUpperCase() + t.kind.substring(1);
                    data.streamParams[name+'TrackMid'] = trans.mid;
                });
            }

            if(conn.streamParams){
                Object.assign(conn.streamParams.send, data.streamParams);
            }
            return data;
        }

        function parseTrackId(stream) {
            let video = [], audio = [];
            stream.getVideoTracks().forEach((track)=>{
                video.push(track.id);
            });
            stream.getAudioTracks().forEach((track)=>{
                audio.push(track.id);
            });
            return { video: video, audio: audio};
        }

        let localStream = await this.getCurrentLocalStream();
        if (localStream) {
            let obj = parseTrackId(localStream);
            map.videoStreamId = localStream.id;
            map.videoStreamVideoTrackId = obj.video.join(',');
            map.videoStreamAudioTrackId = obj.audio.join(',');
        }

        let screenStream = this.getCurrentScreenStream();
        if (screenStream) {
            let obj = parseTrackId(screenStream);
            map.screenStreamId = screenStream.id;
            map.screenStreamVideoTrackId = obj.video.join(',');
            map.screenStreamAudioTrackId = obj.audio.join(',');
        }

        return map;
    }


    async detectVideoDeviceCapabilities({deviceId}) {
        let cap = this.#deviceCap[deviceId];
        if(cap){
           return cap;
        }

        let stream;
        try{
            stream = await GrmWebRTC.getUserMedia({
                video: {exact: deviceId}
                // video: deviceId
            });

            cap = this.#deviceCap[deviceId] = {
                video: stream.getVideoTracks()[0].getCapabilities()
            };
        }catch(e){
            cap = this.#deviceCap[deviceId] = {
                video: {
                    width: 640,
                    height: 360
                }
            };
        }finally{
            await GrmWebRTC.stopMediaStreamVideoTracks(stream);
        }
        return cap;
    }

    // async createLocalStream(options) {
    //     const job = this._createLocalStream(options);
    //     Object.assign(job, {
    //         id: Date.now(),
    //         listener: []
    //     });
    //     const jobs = this.#createLocalStreamJobData.jobs;
    //     jobs.push(job);
    //
    //     try{
    //         const stream = await job;
    //         return stream;
    //     }finally{
    //         const idx = jobs.findIndex(j => j === job);
    //         if(idx >= 0){
    //             jobs.splice(idx, 1);
    //         }
    //     }
    // }

//     async _createLocalStream(options={video:{}, audio: {}}) {
//         let current = this.getLocalDeviceSetting();
//         const roomData = Room.getRoomData();
//
//         options.roomUser = options.roomUser || roomData.me;
//         const roomUserRole = RoomUser.getRoomUserRole(options.roomUser);
//
//         // saved req
//         ['video', 'audio'].forEach(dt => {
//             if(!options[dt]) return;
//             ['deviceId', 'width', 'height', 'frameRate', 'virtualBackgroundType', 'useNoiseCancel'].forEach(type => {
//                 if(options[dt][type] === undefined) return;
//                 current[dt][type] = options[dt][type];
//             });
//         });
//         this.setLocalDeviceSetting(current);
//
//         const roomSetting = roomData.roomInfo?.setting;
//         if(options.video){
//             let {deviceId, width, height, frameRate, virtualBackgroundType} = current.video;
//             Object.assign(options.video, {deviceId, width, height, frameRate, virtualBackgroundType});
//         }
//         if(options.audio){
//             let {deviceId, useNoiseCancel} = current.audio;
//             Object.assign(options.audio, {
//                 deviceId,
//                 useNoiseCancel: roomSetting.useNoiseCancel && useNoiseCancel
//             });
//             roomSttApi.changeSttAudioDevice(deviceId);
//         }
//
//         let createPreview = options.video && this.#streamObj.previewStream.getVideoTracks().length === 0;
//         if(roomUserRole.camera == false){
//             createPreview = options.video = false;
//             if(this.#streamObj.previewStream){
//                 await GrmWebRTC.stopMediaStreamVideoTracks(this.#streamObj.previewStream);
//                 await GrmWebRTC.stopMediaStreamVideoTracks(this.#streamObj.localStream);
//             }
//         }else if(options.video){
//             let track = this.#streamObj.previewStream && this.#streamObj.previewStream.getVideoTracks()[0];
//             if(track && track.readyState !== 'ended'){
//                 let settings = track.getSettings();
//                 /*
// aspectRatio: 1.7777777777777777
// brightness: 128
// colorTemperature: 4000
// contrast: 128
// deviceId: "914e9bea233d88f9289086ac3f726808c4bd6c81c268124877ea6307a3e3699b"
// exposureCompensation: 35
// exposureMode: "continuous"
// exposureTime: 78.125
// focusDistance: 0
// focusMode: "continuous"
// frameRate: 96
// groupId: "40f3d1547fcb4b5699795beed8d40954ef411bf88ca8cb761cb3e47566b2973e"
// height: 180
// resizeMode: "none"
// saturation: 128
// sharpness: 128
// whiteBalanceMode: "continuous"
// width: 320
//                 */
//                 if(
//                     settings.deviceId == options.video.deviceId
//                 ){
//                     if(settings.width >= options.video.width
//                         && settings.height >= options.video.height){
//                         // delete options.video;
//                         createPreview = false;
//                     }else{
//                         console.log('# create prev stream c :',
//                             settings.width+'x'+settings.height,
//                             options.video.width+'x'+options.video.height);
//                         // await GrmWebRTC.stopMediaStreamVideoTracks(this.#streamObj.previewStream);
//                         // await GrmWebRTC.stopMediaStreamVideoTracks(this.#streamObj.localStream);
//                         let cons = track.getConstraints();
//                         cons.width = options.video.width;
//                         cons.height = options.video.height;
//                         try{
//                             await track.applyConstraints(cons);
//                             createPreview = false;
//                         }catch(e){
//                             console.error(e);
//                         }
//                     }
//                 }else{
//                     createPreview = true;
//                 }
//             }
//         }
//
//         // Create Preview Stream
//         if(createPreview){
//             if(this.#streamObj.previewStream){
//                 await GrmWebRTC.stopMediaStreamVideoTracks(this.#streamObj.previewStream);
//             }
//
//             let prevVideo = _.cloneDeep(options.video);
//             Object.assign(prevVideo, {
//                 width: Math.max(prevVideo.width, 1280),
//                 height: Math.max(prevVideo.height, 720),
//                 frameRate: (() => {
//                     let fr = prevVideo.frameRate;
//                     if(!fr){
//                         return 20;
//                     }
//                     const isObject = typeof(prevVideo.frameRate) === 'object';
//                     if(isObject){
//                         fr = prevVideo.frameRate.ideal || prevVideo.frameRate.max || prevVideo.frameRate.min
//                     }
//                     fr = Math.max(fr, 20);
//                     if(isObject){
//                         prevVideo.frameRate.ideal = fr;
//                         return prevVideo.frameRate;
//                     }
//                     return fr;
//                 })()
//             });
//             console.log('create prev stream S');
//             let prevStream;
//             try{
//                 prevStream = await this.createStream({video: prevVideo, roomUser: options.roomUser, _preview: true});
//             }catch(e){
//                 let cap = options.video.deviceId && await this.detectVideoDeviceCapabilities(options.video.deviceId);
//                 Object.assign(prevVideo, {
//                     width: Math.min(prevVideo.width, cap.video.width.max),
//                     height: Math.min(prevVideo.height, cap.video.height.max),
//                 });
//                 prevStream = await this.createStream({video: prevVideo, roomUser: options.roomUser, _preview: true});
//             }
//             if(this.#streamObj.previewStream){
//                 await GrmWebRTC.stopMediaStreamVideoTracks(this.#streamObj.previewStream);
//                 prevStream.getVideoTracks().forEach(t => {
//                     this.#streamObj.previewStream.addTrack(t);
//                 });
//             }else{
//                 this.#streamObj.previewStream = prevStream;
//             }
//
//             // Mobile Portrait Mode
//             // await (async () => {
//             //     const videoTrack = this.#streamObj.previewStream?.getVideoTracks()[0];
//             //     const tmpVideoTrack = videoTrack.clone();
//             //     this.#streamObj.previewStream?.removeTrack(videoTrack);
//             //     this.#streamObj.previewStream?.addTrack(tmpVideoTrack);
//             //
//             //     const cons = videoTrack.getConstraints();
//             //     ['width', 'height', 'frameRate'].forEach(t => {
//             //         cons[t] = options.video[t];
//             //     });
//             //     Object.assign(cons, { resizeMode: 'none' });
//             //
//             //     await videoTrack.applyConstraints();
//             //     if (tmpVideoTrack) {
//             //         this.#streamObj.previewStream?.removeTrack(tmpVideoTrack);
//             //         this.#streamObj.previewStream?.addTrack(videoTrack);
//             //         tmpVideoTrack.stop();
//             //     }
//             // })();
//
//             console.log('create prev stream E :', prevStream, prevStream.getTracks());
//         }
//
//         if(roomUserRole.mic == false){
//             options.audio = false
//             if(this.#streamObj.localStream){
//                 await GrmWebRTC.stopMediaStreamAudioTracks(this.#streamObj.localStream);
//             }
//         }
//         // else if(options.audio){ TODO 권한 및 장치 체크 추후 한번에 정리 해야함
//         //     let track = this.#streamObj.localStream && this.#streamObj.localStream.getAudioTracks()[0];
//         //     if(track){
//         //         let settings = track.getSettings();
//         //         if(settings.deviceId == options.audio.deviceId
//         //             && settings.deviceId == options.audio.deviceId){
//         //             delete options.audio;
//         //         }
//         //     }
//         // }
//
//         let stream;
//
//         // Create Local Stream
//         try{
//             let create = !!options.video || !!options.audio
//             if(options.video){
//                 let videoTrack = this.#streamObj.localStream?.getVideoTracks()[0];
//                 if(!videoTrack && this.#streamObj.previewStream){
//                     videoTrack = this.#streamObj.previewStream.getVideoTracks()[0];
//                     if(videoTrack){
//                         if(
//                             (Device.isTablet() || Device.isMobile())
//                             && Device.isSafari()
//                         ){
//                             // ipad safari 에서 video track 을 clone 할 경우 mute 되버림.
//                             const tracks = this.#streamObj.localStream.getAudioTracks();
//                             this.#streamObj.localStream = this.#streamObj.previewStream;
//                             tracks.forEach(t=>{
//                                 this.#streamObj.localStream.addTrack(t);
//                             });
//                         }else{
//                             videoTrack = videoTrack.clone();
//                             this.#streamObj.localStream?.addTrack(videoTrack);
//                         }
//                     }
//                 }
//                 if(videoTrack){
//                     const settings = videoTrack.getSettings();
//                     if(settings.deviceId
//                       && settings.deviceId !== options.video.deviceId
//                     ){ // 장치가 달라졌을 경우
//                         if(
//                             (Device.isTablet() || Device.isMobile())
//                             && Device.isSafari()
//                         ){
//                             const tracks = this.#streamObj.localStream.getAudioTracks();
//                             this.#streamObj.localStream = this.#streamObj.previewStream;
//                             tracks.forEach(t=>{
//                                 this.#streamObj.localStream.addTrack(t);
//                             });
//                         }else{
//                             GrmWebRTC.stopMediaStreamVideoTracks(this.#streamObj.localStream);
//                             videoTrack = this.#streamObj.previewStream.getVideoTracks()[0];
//                             videoTrack = videoTrack.clone();
//                             this.#streamObj.localStream?.addTrack(videoTrack);
//                         }
//                     }
//
//                     let cons = videoTrack.getConstraints();
//                     ['width', 'height', 'frameRate'].forEach(t => {
//                         cons[t] = options.video[t];
//                     })
//
//                     await videoTrack.applyConstraints(cons);
//                     delete options.video;
//                     create = !!options.audio;
//                 }
//
//                 // mediapipe S /////////////////////////
//                 try{
//                     let mediapipe;
//                     if (this.useVirtualBackground()
//                         && this.#streamObj.localStream?.getVideoTracks().length) {
//                         mediapipe = await RoomMediapipe.getMainMediapipe()
//                         await mediapipe.setStream(this.#streamObj.localStream)
//                         let stream =  await mediapipe.setBackgroundByType(this.getVirtualBackgroundOptions())
//                         this.setDeviceStatus({stream, options:{roomUser: Room.getRoomData().me}})
//
//                         console.log('# apply mediapipe stream:', stream)
//                         this.#streamObj.processedStream.getAudioTracks().forEach(t => {
//                             stream.addTrack(t);
//                         })
//                         this.#streamObj.processedStream = stream;
//                     }else{
//                         if(this.#streamObj.processedStream.getVideoTracks().length > 0){
//                             mediapipe?.stop()
//                         }
//                     }
//
//                 } catch (e) {
//                     if(current.video.virtualBackgroundType === 'custom'){
//                         current.video.virtualBackgroundType = 'none'
//                         current.video.virtualBackgroundUrl = '';
//                         this.setLocalDeviceSetting(current);
//                     }
//                     console.warn('Could not use mediapipie', e)
//                 }
//                 // mediapipe E /////////////////////////
//
//             }
//
//             if(create){
//                 stream = await this.createStream(options);
//                 if (stream?.getAudioTracks().length > 0
//                     &&!!options.audio?.useNoiseCancel
//                     && this.#noiseCancelAvailable
//                     && grmNoiseCancel.isAvailable()) {
//
//                     let errorFunc = (e => {
//                         console.error('noise cancel init failed ', e);
//
//                         this.#noiseCancelAvailable = false;
//                         Room.emit('noise_cancel_failed');
//                         current.audio.useNoiseCancel = false;
//                         this.setLocalDeviceSetting(current);
//                     })
//
//                     try {
//                         await grmNoiseCancel.init();
//                         stream = grmNoiseCancel.setStream({
//                             stream,
//                             stopCurrentTrack: true,
//                             activate: options.audio?.useNoiseCancel,
//                         });
//
//                         grmNoiseCancel.onprocessorerror((error) => {
//                             errorFunc(error);
//                         });
//                     } catch (e) {
//                         errorFunc(e);
//                     }
//                 }
//             }
//         }catch(e){
//             console.error('create stream fail [ls]', options, e);
//             stream = this.#streamObj.previewStream;
//         }
//
//         if(!this.#streamObj.localStream){
//             this.#streamObj.localStream = stream;
//         }else if(stream){
//             if(stream.getAudioTracks().length > 0){
//                 GrmWebRTC.stopMediaStreamAudioTracks(this.#streamObj.localStream);
//                 GrmWebRTC.stopMediaStreamAudioTracks(this.#streamObj.processedStream);
//             }
//             stream.getTracks().forEach(t => {
//                 this.#streamObj.localStream.addTrack(t);
//                 this.#streamObj.processedStream?.addTrack(t);
//             });
//         }
//         this.setDeviceStatus({stream: this.#streamObj.localStream, options})
//
//         if(this.#streamObj.localStream.getVideoTracks().length === 0){
//             if(this.#streamObj.previewStream){
//                 await GrmWebRTC.stopMediaStreamVideoTracks(this.#streamObj.previewStream);
//             }
//         }
//         return {
//             stream: await this.getCurrentLocalStream(true),
//             previewStream: this.getCurrentPreviewStream()
//         };
//     }

    setDeviceStatus({stream, options}){
        if(!stream) return;
        let me = options.roomUser;
        if(stream.getAudioTracks().length > 0){
            stream.getAudioTracks()[0].enabled = me.micStatus === 'on';
        }
        if(stream.getVideoTracks().length > 0){
            stream.getVideoTracks()[0].enabled = me.cameraStatus === 'on';
        }
    }

    async createStream(options={}) {
        return this._createStream(options);
    }
    async _createStream(options={}) {
        let config = _.merge({
            video: {},
            audio: {},
        });

        let roomUser = options.roomUser;
        let role = roomUser && roomUser.roomUserRole;

        // video input
        if(!role.camera || roomUser.cameraStatus === 'none'){
            config.video = false;
        }else{
            if(options.video){
                // let width = Math.max(options.video.width, 320);
                // let height = Math.max(options.video.height, 180);
                let width = options.video.width;
                let height = options.video.height;
                config.video = {
                    width,
                    height,
                    frameRate: options.video.frameRate
                };
                if(options.video.deviceId){
                    config.video.deviceId = {exact: options.video.deviceId};
                    // config.video.deviceId = options.video.deviceId;
                }
            }else{
                config.video = false;
            }
        }

        // audio input
        if(!role.mic || roomUser.micStatus === 'none'){
            config.audio = false;
        }else{
            if(options.audio){
                config.audio = {
                    echoCancellation: true,
                    // autoGainControl: false,
                    noiseSuppression: false,
                    // sampleRate: 22000
                }
                if(options.audio.deviceId){
                    config.audio.deviceId = {exact: options.audio.deviceId};
                    // config.audio.deviceId = options.audio.deviceId;
                }
            }else{
                config.audio = false;
            }
        }

        if(!config.audio && !config.video){
            return Promise.resolve(new MediaStream());
        }

        const retryCount = 2
        console.log('# create stream start', config, options);
        for(let i=0; i < retryCount; i++){
            try{
                const {video, audio} = config;
                let stream = await GrmWebRTC.getUserMedia({video, audio});
                // if(stream.getVideoTracks()[0]){
                //     // facingMode user 일때 가로, 세로 비율이 바뀜 보완 로직
                //     await (async () => {
                //         if(!video || !video.width || !video.height){
                //             return;
                //         }
                //         const track = stream.getVideoTracks()[0];
                //         const settings = track.getSettings();
                //         if(settings.facingMode !== 'user') {
                //             return;
                //         }
                //         let {width, height} = video;
                //         if(typeof(width) === 'object'){
                //             width = width.exact || width.ideal || width.max || width.min;
                //             height = height.exact || height.ideal || height.max || height.min;
                //         }
                //         if(settings.width != width && settings.width == height){
                //             let cons = track.getConstraints();
                //             Object.assign(cons, {
                //                 width: video.height,
                //                 height: video.width,
                //                 aspectRatio: width/height
                //             });
                //             await track.applyConstraints(cons);
                //         }
                //     })();
                // }
                return stream;
            }catch(e){
                if(i === retryCount - 1){
                    console.error('# create stream(retry[%d]) fail :', i, config, options, e);
                    throw e;
                }else{
                    console.warn('# create stream(retry[%d]) fail :', i, config, options, e);
                } 
            }            
        }
    }

    async activateNoiseCancel(activate){
    }

    getVideoOnlyStream({stream}) {
        if (!stream) {
            return null;
        }
        if (stream._v_only_stream) {
            return stream._v_only_stream;
        }

        const v_stream = stream._v_only_stream = new MediaStream(stream.getVideoTracks());
        v_stream._ori_stream = stream;

        ['add', 'remove'].forEach(type => {
            stream[`__ori__${type}__track`] = stream[`${type}Track`];
            stream[`${type}Track`] = track => {
                stream[`__ori__${type}__track`].call(stream, track);

                if (!stream._v_only_stream || track.kind !== 'video') return;
                stream._v_only_stream[`${type}Track`](track);
            }
        });

        return v_stream;
    }
}

export const RoomCallStream = new RoomCallStreamApi();